import { FormInstance, message, Modal } from 'antd';
import { playlistRuleService } from '../services/playlistRuleService';
interface ContentRuleHook {
  handleSave: () => void;
}

interface ContentRuleHandlersProps {
  form: FormInstance;
  playlistId: number;
}

type TagRule = {
  value_type: 'tag';
  value: string;
};

type RecentRule = {
  value_type: 'recent';
  value: string;
};

type SeriesOrSeasonRule = {
  value_type: 'series' | 'season';
  value: string;
};

type Rule = TagRule | RecentRule | SeriesOrSeasonRule;

interface FormValues {
  tag?: { value: string };
  recent?: number;
  series?: number[];
  season?: number[];
}

export const playlistRuleHandlers = ({
  form,
  playlistId,
}: ContentRuleHandlersProps): ContentRuleHook => {
  const handleSave = async (): Promise<void> => {
    try {
      const values = (await form.validateFields()) as FormValues;
      const rules: Rule[] = [];
      for (const [key, value] of Object.entries(values)) {
        if (!value) continue;

        if (key === 'tag') {
          rules.push({
            value: value.join(','),
            value_type: 'tag',
          });
        } else if (key === 'recent') {
          rules.push({
            value: String(value),
            value_type: key,
          });
        } else if (key === 'series' || key === 'season') {
          rules.push({
            value: value.join(','),
            value_type: key,
          });
        }
      }

      await playlistRuleService.upsertPlaylistRule(playlistId, rules);
      message.success('Rule has been saved.');
    } catch (error) {
      Modal.error({
        title: 'Error',
        content: 'An error occurred while saving.',
        okText: 'Confirm',
      });
      console.error(error);
    }
  };

  return {
    handleSave,
  };
};
